export const FORM_NAME = 'new-post-form';
export const EDIT_FORM_NAME = 'edit-post-form';
export const OBSERVATION_FORM_NAME = 'new-observation-form';
export const EDIT_OBSERVATION_FORM_NAME = 'edit-observation-form';

export const knownFormValues = [FORM_NAME, EDIT_FORM_NAME, OBSERVATION_FORM_NAME, EDIT_OBSERVATION_FORM_NAME];

export const DisableFeedbackField = 'disableFeedback';
export const WILL_OVERRIDE_SUBSCRIPTION_SETTINGS = 'willOverrideSubscriptionSettings';
export const SEND_AS_SMS_FIELD = 'sendAsSms';
